import { maintenanceForwardingEntryTypeLabels } from '@shared/maintenance/forwardingEntryLabels'

export const checkinEntryLabel = (checkinEntryType?: string | null): string | undefined =>
  checkinEntryType ? maintenanceForwardingEntryTypeLabels()[checkinEntryType] : undefined
